import jsCookies from 'js-cookie'
import { getUUIDHeader, getSignatureHeader } from '../common/js/signature'
import get from 'lodash.get'
import router from '../router'
import { Toast } from 'vant' 

// 请求配置处理
 function handleRequestConfig (params) {
  let {token, tokenBao, tokenRequired, method, headers, options, requestBody} = params
  // 判断是否需要手动传token
  if (token)  {
    headers.Authorization = token
  } else {
    // 判断是否需要获取本地token
    if (tokenRequired) {
      const token = jsCookies.get('token')     
      headers.Authorization = decodeURIComponent(token)
    }
  }
  let fetchParams = {
    method,
    headers,
  }
  if (method == 'POST') {
    // if (options.body) {
    //   fetchParams.body = options.body
    // } else {
    //   fetchParams.headers['Content-Type'] = 'application/x-protobuf'
    // }
    fetchParams.body = JSON.stringify(requestBody)
    fetchParams.headers['Content-Type'] = 'application/json'
  }

  return fetchParams
}


/**
 * @param {*} msgType 接口名称
 * @param {*} requestBody 请求体参数
 * @param {*} responseType 返回值
 */
async function request(options = {}, config = {}) {
  const tokenRequired = get(config, 'TOKEN_REQUIRED') // syx开始处理登陆事宜！
  const tokenBao = get(config, 'TOKEN_BAO')
  const token = get(config, 'TOKEN') // syx开始处理登陆事宜2 云仓补录 传的是用户的token哦～
  const errAction = get(config, 'ERROR_ACTION') // 异常处理
  const isDebugger = get(config, 'DEBUGGER')

  const toast = (message) => errAction === 'toast' && Toast(message)
  const errorMessage = (message) => errAction === 'message' && ErrorMessage(message)
  if (isDebugger) debugger
  // 加密 reqeust
  const requestBody = options.data
  console.log(requestBody);
  const { url, method = 'GET', headers = {} } = options
  const uuidHeader = getUUIDHeader()
  headers['X-authorize-uuid'] = uuidHeader
  headers['Content-Type'] = 'application/json'
  headers['Signature'] = getSignatureHeader(uuidHeader)  
  const fetchParams = handleRequestConfig({token, tokenBao, tokenRequired, method, headers, options, requestBody})
  let refer = options.refer || encodeURIComponent(location.href)
  const t = jsCookies.get('token') 
  if(!t || t === 'undefined'){
    router.replace({ path: `/login?refer=${refer}` }) // 到登录页重新获取token
  }
  console.log(fetchParams);
  return new Promise((resolve, reject) => {
    fetch(
      url,
      fetchParams
    ).then(res => {
      const { status: httpStatus } = res
      if (httpStatus === 200) {
        // arrayBuffer 转换 很关键
        return res.json()
      } else if (httpStatus === 401) {
        if (reviewTokenRequired) {
          router.replace({ path: `/review-series/review-login` }) // 到登录页重新获取token
        } else {
          router.replace({ path: `/login?refer=${refer}${businessId ? ('&businessId='+businessId) : ''}` }) // 到登录页重新获取token
        }
        toast('请先登录');
        return undefinedw
      } else {
        toast('服务异常，请稍后重试~~')
        console.log('res', res)
        console.log('httpStatus', httpStatus)
        return undefined
      }
    }, () => {
      // 网络异常
      console.warn(err)
      toast('网络异常~~')
      reject(new Error('网络异常~~'))
      throw new Error('网络异常~~')
    }).then(response => {
      if (!response) {
        // 所有异常收敛到此 reject 出去
        console.log('===> 接口异常 reject no response')
        reject()
        return
      }
      console.log(response);
      resolve(response)
    })
  })
}

export default request
